import instance from '../config/axios';
import qs from 'qs';
import { ClinicData, GetAssociatedDoctorItem } from '../interface/interface';
import { AxiosError } from 'axios';

export const getAllClinic = async (
  pageIndex: number,
  pageSize: number,
  token: string,
) => {
  try {
    const response = await instance.get(
      `/api/v1/clinic/list?${qs.stringify({ page: pageIndex, limit: pageSize })}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (err) {
    console.error(err);
    return (err as AxiosError).response?.status as number;
  }
};

export const createClinic = async (clinicData: ClinicData, token: string) => {
  try {
    const response = await instance.post('/api/v1/clinic/onboard', clinicData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (err) {
    console.error(err);
    return false;
  }
};

export const getSingleClinicInfo = async (clinicId: string, token: string) => {
  try {
    const response = await instance.get(`/api/v1/clinic/${clinicId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err) {
    console.error(err);
    return (err as AxiosError).response?.status as number;
  }
};

export const updateClinic = async (
  clinicId: string,
  clinicData: ClinicData,
  token: string,
) => {
  try {
    const response = await instance.put(
      '/api/v1/clinic/update',
      { ...clinicData, id: clinicId },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return response.status;
  } catch (err) {
    console.error(err);
    return false;
  }
};

export const getAssociatedClinics = async (
  accessToken: string,
  clinicId = 0,
): Promise<number | Array<GetAssociatedDoctorItem>> => {
  try {
    const response = await instance({
      method: 'GET',
      url: `/api/v1/clinic/associate/doctor/${clinicId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (err) {
    console.log(err);
    return (err as AxiosError).response?.status as number;
  }
};

export const addAssociatedClinics = async (
  accessToken: string,
  clinicId: number,
  doctorList: number[],
) => {
  try {
    const response = await instance({
      method: 'PUT',
      url: '/api/v1/clinic/associate/doctor',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: { clinicId, doctorList },
    });

    return response.status;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status as number;
  }
};

export const breakAssociations = async (
  accessToken: string,
  clinicId: number,
  doctorList: number[],
) => {
  try {
    const response = await instance({
      method: 'DELETE',
      url: '/api/v1/clinic/associate/doctor',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: { clinicId, doctorList },
    });

    return response.status;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status as number;
  }
};
